/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookie_Consent_Payment_DescInputs */

const en_cookie_consent_payment_desc = /** @type {(inputs: Cookie_Consent_Payment_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essential for payment processing, loads only on payment pages (Stripe)`)
};

const de_cookie_consent_payment_desc = /** @type {(inputs: Cookie_Consent_Payment_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für die Zahlungsabwicklung erforderlich, wird nur auf Zahlungsseiten geladen (Stripe)`)
};

const fr_cookie_consent_payment_desc = /** @type {(inputs: Cookie_Consent_Payment_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essentiel pour le traitement des paiements, charge uniquement sur les pages de paiement (Stripe)`)
};

const es_cookie_consent_payment_desc = /** @type {(inputs: Cookie_Consent_Payment_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esencial para el procesamiento de pagos, se carga solo en paginas de pago (Stripe)`)
};

const it_cookie_consent_payment_desc = /** @type {(inputs: Cookie_Consent_Payment_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essenziale per l'elaborazione dei pagamenti, caricato solo nelle pagine di pagamento (Stripe)`)
};

const nl_cookie_consent_payment_desc = /** @type {(inputs: Cookie_Consent_Payment_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essentieel voor betalingsverwerking, wordt alleen geladen op betaalpagina's (Stripe)`)
};

const pl_cookie_consent_payment_desc = /** @type {(inputs: Cookie_Consent_Payment_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niezbedne do przetwarzania platnosci, ladowane tylko na stronach platnosci (Stripe)`)
};

const fi_cookie_consent_payment_desc = /** @type {(inputs: Cookie_Consent_Payment_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Välttämätön maksunkäsittelyyn, ladataan vain maksusivuilla (Stripe)`)
};

const da_cookie_consent_payment_desc = /** @type {(inputs: Cookie_Consent_Payment_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nodvendig for betalingsbehandling, indlases kun pa betalingssider (Stripe)`)
};

const sv_cookie_consent_payment_desc = /** @type {(inputs: Cookie_Consent_Payment_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nodvandig for betalningshantering, laddas bara pa betalningssidor (Stripe)`)
};

/**
* | output |
* | --- |
* | "Essential for payment processing, loads only on payment pages (Stripe)" |
*
* @param {Cookie_Consent_Payment_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cookie_consent_payment_desc = /** @type {((inputs?: Cookie_Consent_Payment_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookie_Consent_Payment_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cookie_consent_payment_desc(inputs)
	if (locale === "fr") return fr_cookie_consent_payment_desc(inputs)
	if (locale === "es") return es_cookie_consent_payment_desc(inputs)
	if (locale === "it") return it_cookie_consent_payment_desc(inputs)
	if (locale === "nl") return nl_cookie_consent_payment_desc(inputs)
	if (locale === "pl") return pl_cookie_consent_payment_desc(inputs)
	if (locale === "fi") return fi_cookie_consent_payment_desc(inputs)
	if (locale === "da") return da_cookie_consent_payment_desc(inputs)
	if (locale === "sv") return sv_cookie_consent_payment_desc(inputs)
	return en_cookie_consent_payment_desc(inputs)
});